<div fxLayout='column' fxLayoutAlign='center center'>
  <div fxFlex='auto'>
    <h1>Oops!</h1>
    <h2>We can't seem to find the page you're looking for.</h2>
    <h5>Error 404</h5>
  </div>
</div>
